import { GamingLimitsData } from "@sazka/ng/rg-limits/model/gaming-limits-data";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { useCookieStorage } from "@sazka/utils/use-storage";
import { BankAccountNumbers } from "../models/bank-account-numbers";
import { IdScanPlayer, IdScanQrCode, IdScanState } from "../models/id-scan-transfer-models";
import { InvestigationResult } from "../models/investigation-results";
import { LoginData, LoginDataToSave, LoginResponse } from "../models/login-data";
import { PersonalData } from "../models/personal-data";

const registrationPath = "/api/registration";
const idScanPath = registrationPath + "/id-scan";
const idScanTransferPath = registrationPath + "/id-scan-transfer";

export async function postLoginData(data: LoginData): Promise<LoginResponse> {
    const storage = useCookieStorage();

    const loginDataToSave: LoginDataToSave = {
        email: data.email,
        password: data.password,
        bonusId: data.bonusId,
        allowEmails: data.allowEmails,
        playerAlternateReference: storage.getItem("aff"),
    };

    const response = await httpClient.post<LoginResponse>(`${registrationPath}/login-data`, loginDataToSave);
    return response.data;
}

export async function postPersonalData(data: PersonalData): Promise<BankAccountNumbers> {
    const response = await httpClient.post<BankAccountNumbers>(`${registrationPath}/personal-data`, data);
    return response.data;
}

export async function postBankAccount(bankAccountNumber: string): Promise<void> {
    await httpClient.post(`${registrationPath}/bank-account`, { bankAccountNumber: bankAccountNumber });
}

export async function postGamingLimits(data: GamingLimitsData): Promise<void> {
    await httpClient.post(`${registrationPath}/gaming-limits`, data);
}

export async function postVerification(hid: string, email: string): Promise<void> {
    const data = { hid, email };
    await httpClient.post(`${registrationPath}/verification`, data);
}

export async function postInvestigationStart(uploadSessionId: string): Promise<InvestigationResult> {
    const response = await httpClient.post<InvestigationResult>(idScanPath, { uploadSessionId });
    return response.data;
}

export async function getInvestigation(): Promise<InvestigationResult> {
    const response = await httpClient.get<InvestigationResult>(idScanPath);
    return response.data;
}

export async function finishIdScan(): Promise<void> {
    await httpClient.put(idScanPath);
}

export async function cancelIdScan(): Promise<void> {
    await httpClient.delete(idScanPath);
}

export async function verifyIdScan(): Promise<void> {
    await httpClient.put(idScanPath + "/verify");
}

export async function startIdScanTransfer(): Promise<IdScanQrCode> {
    const response = await httpClient.post<IdScanQrCode>(idScanTransferPath);
    return response.data;
}
export async function getIdScanTransferState(guid: string): Promise<IdScanState> {
    const response = await httpClient.get<{ state: IdScanState }>(`${idScanTransferPath}/${guid}`);
    return response.data.state;
}

export async function finishIdScanTransfer(guid: string): Promise<void> {
    await httpClient.put(`${idScanTransferPath}/${guid}`);
}

export async function cancelIdScanTransfer(guid: string): Promise<void> {
    await httpClient.delete(`${idScanTransferPath}/${guid}`);
}

export async function keepAliveIdScanTransfer(guid: string): Promise<void> {
    await httpClient.put(`${idScanTransferPath}/${guid}/keep-alive`);
}

export async function getIdScanTransferSession(guid: string): Promise<IdScanPlayer> {
    const response = await httpClient.get<IdScanPlayer>(`${idScanTransferPath}/${guid}/login`);
    return response.data;
}
